import OnlyLoadingPage from "components/loading_page";
import Styles from "css/normal_css/mobile/normal_main_m.module.css";
import { getCommunityData } from "firebase_/firebase_function/firebase_community";
import { getBlockData } from "firebase_/firebase_function/firebase_user";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useUser } from "util/context/user_context";
import { formatDate } from "util/function/function";

const NewCommunityStoryM = () => {
  const [communityLatest_3, setCommunityLatest_3] = useState([]);
  const [initLoading, setInitLoading] = useState(true);
  const { userData } = useUser();

  useEffect(() => {
    fetchCommunityLatest_3();
  }, []);

  const handleBlockData = async () => {
    const data = await getBlockData(userData.docId);
    return data;
  };

  /// ✅ 최신 커뮤니티글 3개 불러오기
  const fetchCommunityLatest_3 = async () => {
    const blockData = await handleBlockData();
    const response = await getCommunityData("", 5, null, blockData);
    if (response) {
      setCommunityLatest_3(response);
      setInitLoading(false);
    }
  };

  return (
    <>
      <div className={Styles.sectionWrapper}>
        <div className={Styles.sectionHeader}>
          <div className="f18_1F2937_W700">커뮤니티</div>
          <NavLink
            to={"/community"}
            className={`f14_6B7280_W400 ${Styles.removeDecoration}`}
            style={{ cursor: "pointer" }}
          >
            더보기
          </NavLink>
        </div>
        <div className={Styles.sectionSpacer20} />
        {initLoading && (
          <div style={{ display: "flex", height: "240px" }}>
            <OnlyLoadingPage />
          </div>
        )}

        {!initLoading &&
          (communityLatest_3.length === 0 ? (
            <div
              style={{
                display: "flex",
                height: "240px",
                justifyContent: "center",
                alignItems: "center",
              }}
              className="f16_a0a0a0_W600"
            >
              작성된 글이 없습니다.
            </div>
          ) : (
            Array.from({ length: 5 }).map((_, index) =>
              communityLatest_3[index] ? (
                <NavLink
                  to={`/community/${communityLatest_3[index].docId}`}
                  className={`${Styles.communityItem}  ${Styles.removeDecoration}`}
                  key={index}
                >
                  <div
                    className="f16_000000_W400 Styles.itemTitle"
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      marginRight: "8px",
                    }}
                  >
                    {communityLatest_3[index].title}
                  </div>
                  <div className={Styles.spacer8} />
                  <div className="f14_6B7280_W400">
                    {formatDate(communityLatest_3[index].createDate)}
                  </div>
                  <div className={Styles.spacer16} />
                  {index !== 4 && (
                    <>
                      <div className={Styles.itemDivider} />
                      <div className={Styles.spacer16} />
                    </>
                  )}
                </NavLink>
              ) : (
                <>
                  {/* 빈 박스 */}
                  <div
                    style={{
                      height: "57px",
                      backgroundColor: "#ffffff",
                      borderBottom: index !== 4 && "1px solid #E5E7EB",
                      marginBottom: index !== 4 && "16px",
                    }}
                  />
                </>
              )
            )
          ))}
      </div>
    </>
  );
};

export default NewCommunityStoryM;
